<template>
    <div>
        <a-row type="flex" class="dash-section dash-greeting" justify="space-between" align="middle">
            <h2 class="greeting">Helo, {{ user().name }}</h2>
            <h2 class="date">{{ moment().format('LLLL') }}</h2>
        </a-row>

        <a-card class="dash-section">
            <a-row type="flex" justify="space-between">
                <a-col span="11">
                    <img src="/assets/bankjateng/jateng-staff.png" style="width: 100%"/>
                </a-col>
                <a-col span="12">
                    <div class="bg-collateral">
                        <h2 class="training-title">Selamat Datang di {{ training.description }}</h2>
                        <br>
                        <br>
                        <a-card :bordered="false">
                            <a-row type="flex" align="middle">
                                <a-col :span="6" class="text-center">
                                    <a-avatar :size="100" src="/assets/bk/ahadian.png"/>
                                </a-col>
                                <a-col :span="18">
                                    <h3 class="quote">
                                        Untuk mendapatkan apa yang tidak pernah kita miliki, kita harus melakukan hal
                                        yang tidak pernah kita lakukan sebelumnya.
                                    </h3>
                                    <br>
                                    <h3>
                                        <strong><span class="quote-author">Ahadian</span></strong>
                                        <br>Project Manager BK
                                    </h3>
                                </a-col>
                            </a-row>
                        </a-card>
                    </div>
                </a-col>
            </a-row>
        </a-card>

        <a-row type="flex" align="stretch" class="dash-section" :gutter="[16,16]">
            <a-col :span="8">
                <h1 class="section-title alt">PROFIL</h1>
                <a-card class="profile-card" :bordered="false">
                    <a-row :gutter="[16,16]" type="flex" align="middle">
                        <a-col :span="10" class="text-center">
                            <a-avatar :src="user().photo" :size="120"/>
                        </a-col>
                        <a-col :span="14">
                            <img class="client-logo" src="/assets/bankjateng/jateng-logo.png"/>
                            <br>
                            <br>
                            <h2>{{ user().name }}</h2>
                            <br>
                            <p><strong>{{ role_text }}</strong></p>
                            <h3>{{ training.description }}</h3>
                            <br>
                            <a-button type="primary"
                                      :href="routeUri('admin.setting.profile.show', { user_hash: user().hash })">Lihat
                                Profil
                            </a-button>
                        </a-col>
                    </a-row>
                </a-card>
            </a-col>
            <a-col :span="16">
                <h1 class="section-title alt">PENGUMUMAN</h1>
                <div class="dash-announcement">
                    <a-skeleton :loading="announcement.loading" active>
                        <h2 class="title">{{ latest_announcement.title }}</h2>
                        <div class="content" v-html="latest_announcement.description"></div>
                        <br>
                        <a-button type="primary" :href="routeUri('admin.classical.announcement')">Selengkapnya
                        </a-button>
                    </a-skeleton>
                </div>
            </a-col>
        </a-row>

        <a-row class="dash-section" :gutter="[16,16]">
            <a-col :span="14">
                <a-card class="section-card" :bordered="false" :headStyle="{ background: '#7f2626'}">
                    <div slot="title">
                        <h2 class="section-card-title">NILAI KOMPETENSI</h2>
                        <span class="section-card-desc">Nilai rata-rata seluruh peserta pada tiap kompetensi</span>
                    </div>
                    <a-skeleton :loading="competency.loading" active>
                        <classical-dashboard-chart :chart-data="chart_data" :options="CHART_OPTIONS" />
                    </a-skeleton>
                </a-card>

                <a-card class="section-card" v-if="role === 'administrator'" :bordered="false" :headStyle="{ background: '#7f2626'}" style="margin-top: 24px;">
                    <div slot="title">
                        <h2 class="section-card-title">PERFORMANCE GROWTH</h2>
                        <span class="section-card-desc">Grafik rata-rata perkembangan seluruh peserta.</span>
                    </div>
                </a-card>

                <a-card v-if="is_attendant" class="section-card" :bordered="false" :headStyle="{ background: '#7f2626'}">
                    <div slot="title">
                        <h2 class="section-card-title">LEADERBOARD</h2>
                        <span class="section-card-desc">Top 5 Peserta</span>
                    </div>
                    <a-skeleton :loading="score.loading" active>
                        <a-list item-layout="vertical" size="large" style="margin-bottom: 24px;"
                                :data-source="score.items">
                            <a-list-item slot="renderItem" :key="item.hash" slot-scope="item,index">
                                <a-row type="flex" align="middle">
                                    <a-col flex="50px" class="text-center">
                                        <h2>{{ index + 1 }}</h2>
                                    </a-col>
                                    <a-col flex="80px" class="text-center">
                                        <a-avatar :src="item.photo" :size="60"/>
                                    </a-col>
                                    <a-col flex="auto">
                                        <h3>{{ item.name.toUpperCase() }}</h3>
                                    </a-col>
                                    <a-col flex="80px">
                                        <h2>{{ parseFloat(item.score_data.total_score).toFixed(2) }}</h2>
                                    </a-col>
                                </a-row>
                                <span slot="actions" title="Rata-rata Nilai Resume">
                                        <a-icon type="form"/>
                                        {{ item.score_data.avg_resume }}
                                    </span>
                                <span slot="actions" title="Rata-rata Nilai Ujian">
                                        <a-icon type="audit"/>
                                        {{ item.score_data.avg_exam }}
                                    </span>
                            </a-list-item>
                        </a-list>

                        <a-button type="primary" :href="this.routeUri('admin.classical.report.highest_score')">Selengkapnya</a-button>
                    </a-skeleton>
                </a-card>

                <a-row style="margin: 24px 0; align-items: stretch;" :gutter="[16,16]" type="flex">
                    <a-col :span="12">
                        <a-card :bordered="false" class="dash-chips">
                            <a-row type="flex" align="middle">
                                <a-col :span="12" class="text-center">
                                    <img src="/assets/bk/icon-contact.png"/>
                                </a-col>
                                <a-col :span="12">
                                    <h2>Contact Support</h2>
                                    <p>Ada Kendala atau Butuh info terkait sistem & pelatihan</p>
                                    <a-button type="primary" :href="routeUri('admin.classical.forum')">CHAT ADMIN
                                    </a-button>
                                </a-col>
                            </a-row>
                        </a-card>
                    </a-col>
                    <a-col :span="12">
                        <a-card :bordered="false" class="dash-chips">
                            <a-row type="flex" align="middle">
                                <a-col :span="12" class="text-center">
                                    <img src="/assets/bk/icon-performance.png"/>
                                </a-col>
                                <a-col :span="12">
                                    <h2>Performance</h2>
                                    <p>Akses nilai resume dan ujian online anda.</p>
                                    <a-button type="primary"
                                              :href="is_attendant ? routeUri('admin.classical.attendant.recap.score') : routeUri('admin.classical.report') ">
                                        LIHAT REKAP NILAI
                                    </a-button>
                                </a-col>
                            </a-row>
                        </a-card>
                    </a-col>
                </a-row>
            </a-col>

            <a-col :span="10">
                <template v-if="is_attendant">
                    <a-card class="section-card" :bordered="false" :headStyle="{ background: '#7f2626'}">
                        <div slot="title">
                            <h2 class="section-card-title">AKTIVITAS</h2>
                            <span class="section-card-desc">Jadwal Sesi dan Ujian</span>
                        </div>
                        <a-skeleton :loading="timeline.loading" active>
                            <a-timeline v-if="timeline_data.length > 0">
                                <a-timeline-item v-for="(item,idx) in timeline_data" :key="`timeline-${idx}`"
                                                 :color="timeline.colors[item.type]">
                                    <a-icon slot="dot" type="clock-circle-o" style="font-size: 16px;"
                                            v-if="item.type === 'exam'"/>

                                    <a-divider orientation="left" v-if="item.type === 'divider'">{{
                                            item.name
                                        }}
                                    </a-divider>
                                    <span v-else><strong>[{{ item.time.format('HH:mm') }}]</strong> {{
                                            item.name
                                        }}</span>
                                </a-timeline-item>
                            </a-timeline>
                            <div v-else>
                                <strong class="text-center">Tidak ada jadwal kegiatan</strong>
                            </div>
                        </a-skeleton>
                    </a-card>
                </template>
                <template v-else>
                    <a-card class="section-card" :bordered="false" :headStyle="{ background: '#7f2626'}">
                        <div slot="title">
                            <h2 class="section-card-title">LEADERBOARD</h2>
                            <span class="section-card-desc">Top 5 Peserta</span>
                        </div>
                        <a-skeleton :loading="score.loading" active>
                            <a-list item-layout="vertical" size="large" style="margin-bottom: 24px;"
                                    :data-source="score.items">
                                <a-list-item slot="renderItem" :key="item.hash" slot-scope="item,index">
                                    <a-row type="flex" align="middle">
                                        <a-col flex="50px" class="text-center">
                                            <h2>{{ index + 1 }}</h2>
                                        </a-col>
                                        <a-col flex="80px" class="text-center">
                                            <a-avatar :src="item.photo" :size="60"/>
                                        </a-col>
                                        <a-col flex="auto">
                                            <h3>{{ item.name.toUpperCase() }}</h3>
                                        </a-col>
                                        <a-col flex="80px">
                                            <h2>{{ parseFloat(item.score_data.total_score).toFixed(2) }}</h2>
                                        </a-col>
                                    </a-row>
                                    <span slot="actions" title="Rata-rata Nilai Resume">
                                        <a-icon type="form"/>
                                        {{ item.score_data.avg_resume }}
                                    </span>
                                    <span slot="actions" title="Rata-rata Nilai Ujian">
                                        <a-icon type="audit"/>
                                        {{ item.score_data.avg_exam }}
                                    </span>
                                </a-list-item>
                            </a-list>

                            <a-button type="primary" v-if="!is_attendant" :href="this.routeUri('admin.classical.report.highest_score')">
                                Selengkapnya
                            </a-button>
                        </a-skeleton>
                    </a-card>
                </template>
            </a-col>
        </a-row>
    </div>
</template>
<script>
const CHART_OPTIONS = {
    responsive: true,
    maintainAspectRatio: false,
    lineTension: 1,
    scales: {
        yAxes: [
            {
                ticks: {
                    beginAtZero: true,
                    padding: 25
                }
            }
        ]
    },
    legend: {
        display: false
    },
    tooltips: {
        callbacks: {
            label: function (tooltipItem, data) {
                return "Count: " + tooltipItem.value
            }
        }
    }
}

export default {
    computed: {
        training() {
            return this.$laravel.training
        },
        active_module() {
            return this.$laravel.active_module
        },
        role() {
            let roles = this.$laravel.roles[this.active_module.module.identifier]

            if (roles instanceof Array)
                return roles[0]

            return roles
        },
        role_text() {
            switch (this.role) {
                case 'admin':
                    return 'Administator'
                case 'attendant':
                    return 'Peserta'
                case 'inspirator':
                    return 'Inspirator'
                case 'project-manager':
                    return 'PM Bangun Kapasitas'
                case 'project-owner':
                    return 'PO Bangun Kapasitas'
                case 'project-owner-client':
                    return 'PO Client'
                case 'project-manager-client':
                    return 'PM Client'
                case 'project-sponsor':
                    return 'Project Sponsor'
                default:
                    return 'Undefined'
            }
        },
        latest_announcement() {
            if (this.announcement.loading || this.announcement.items.length < 1)
                return {
                    title: '',
                    description: ''
                }

            return this.announcement.items[0]
        },
        is_attendant() {
            return this.role === 'attendant'
        },
        chart_data() {
            if (this.competency.loading)
                return {labels: [], datasets: []}

            // processing chart data
            let labels = []
            let categories = []

            this.competency.items.categories_avg.forEach((i) => {
                categories.push(i.material_avg)
                labels.push(i.name)
            })

            return {
                labels,
                datasets: [{
                    data: categories,
                    barThickness: 50,
                    backgroundColor: '#f87979'
                }]
            }
        },
        timeline_data() {
            if (this.timeline.loading) {
                return [];
            }

            let collection = []
            let vm = this

            // modify data
            this.timeline.items.forEach((i) => {
                collection.push({
                    type: 'exam',
                    name: 'Ujian ' + i.name,
                    time: vm.moment(i.exam_time_start)
                })
                collection.push({
                    type: 'session',
                    name: i.name,
                    time: vm.moment(i.session_time_start)
                })
            })

            if (collection.length > 0) {
                // order modified data
                collection = _.orderBy(collection, 'time', 'asc')

                let startDate = collection[0].time
                let newCollection = []

                collection.forEach((i, n) => {
                    if (n === 0 || i.time.isSame(startDate, 'date') === false) {
                        startDate = i.time

                        newCollection.push({
                            type: 'divider',
                            name: startDate.format('dddd LL'),
                            time: ''
                        })
                    }
                    newCollection.push(i)
                })

                return newCollection
            }

            return [];

        }
    },
    data() {
        return {
            CHART_OPTIONS,
            announcement: {
                loading: false,
                items: []
            },
            competency: {
                loading: false,
                items: []
            },
            timeline: {
                loading: false,
                items: [],
                colors: {
                    exam: 'red',
                    session: 'blue',
                    divider: 'gray'
                }
            },
            score: {
                loading: false,
                items: []
            },
            performance: {
                loading: false,
                items: [],
                selected: null
            }
        }
    },
    created() {
        this.getCompetencies()
        this.getAnnouncements()
        this.getPerformanceGrowth()

        if (this.is_attendant) {
            this.getTimeline()
        }

        this.getScores()
    },
    methods: {
        getCompetencies() {
            this.competency.loading = true

            this.$http
                .get(this.routeUri("api.dashboard.classical.competency-scores"))
                .then(r => this.competency.items = r.data)
                .catch(e => this.handleXhrError(e))
                .finally(() => this.competency.loading = false)
        },
        getAnnouncements() {
            this.announcement.loading = true

            this.$http
                .get(this.routeUri("api.dashboard.announcement"))
                .then(r => this.announcement.items = r.data.announcements)
                .catch(e => this.handleXhrError(e))
                .finally(() => this.announcement.loading = false)
        },
        getTimeline() {
            this.timeline.loading = true

            this.$http
                .get(this.routeUri("api.dashboard.classical.timeline"))
                .then(r => this.timeline.items = r.data.timeline)
                .catch(e => this.handleXhrError(e))
                .finally(() => this.timeline.loading = false);
        },
        getScores() {
            this.score.loading = true

            this.$http
                .get(this.routeUri("api.report.classical.highest_score"), {params: {xhr: true, limit: 5}})
                .then(r => this.score.items = r.data)
                .catch(e => this.handleXhrError(e))
                .finally(() => this.score.loading = false)
        },
        getPerformanceGrowth() {
            this.performance.loading = true
            this.$http
                .get(this.routeUri('api.dashboard.classical.performance-growth'))
                .then((r) => this.performance.items = r.data)
                .catch(e => this.handleXhrError(e))
                .finally(() => {
                    this.performance.loading = false
                    this.performance.selected = this.performance.items[0]
                })
        }
    }
}
</script>
